"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Color = require('color');
// import * as Color from 'color';
var react_color_1 = require("react-color");
var antd_1 = require("antd");
require("./ColorField.css");
var LocaleWrapper_1 = require("../../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../../locale/en_US"));
var _isEqual = require('lodash/isEqual');
/**
 * ColorField
 */
var ColorField = /** @class */ (function (_super) {
    __extends(ColorField, _super);
    function ColorField(props) {
        var _this = _super.call(this, props) || this;
        _this.onColorPreviewClick = function () {
            _this.setState({
                colorPickerVisible: !_this.state.colorPickerVisible
            });
        };
        _this.onChangeComplete = function (colorResult) {
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange(colorResult.hex);
            }
        };
        _this.state = {
            colorPickerVisible: false
        };
        return _this;
    }
    ColorField.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var diffProps = !_isEqual(this.props, nextProps);
        var diffState = !_isEqual(this.state, nextState);
        return diffProps || diffState;
    };
    ColorField.prototype.render = function () {
        var _a = this.state.colorPickerVisible, colorPickerVisible = _a === void 0 ? false : _a;
        var _b = this.props, color = _b.color, locale = _b.locale;
        var textColor;
        if (!color) {
            textColor = '#000000';
        }
        else {
            try {
                textColor = Color(color).negate().grayscale().string();
            }
            catch (error) {
                textColor = '#000000';
            }
        }
        return (React.createElement("div", { className: "editor-field color-field" },
            React.createElement("div", { className: "color-preview-wrapper" },
                React.createElement(antd_1.Button, { className: "color-preview editor-field", style: {
                        backgroundColor: color,
                        color: textColor
                    }, onClick: this.onColorPreviewClick }, colorPickerVisible ? locale.closeText : color ? locale.editText : locale.chooseText),
                colorPickerVisible ?
                    React.createElement(react_color_1.SketchPicker, { color: color, disableAlpha: true, onChangeComplete: this.onChangeComplete }) : null)));
    };
    ColorField.defaultProps = {
        locale: en_US_1.default.GsColorField
    };
    ColorField.componentName = 'ColorField';
    return ColorField;
}(React.Component));
exports.ColorField = ColorField;
exports.default = LocaleWrapper_1.localize(ColorField, ColorField.componentName);
//# sourceMappingURL=ColorField.js.map